import { JSX } from 'react';

export function addLineBreaks(text: string): (string | JSX.Element)[] {
  return text
    .split('\n')
    .flatMap((line, index, arr) => [
      line,
      ...(index < arr.length - 1 ? [<br key={index} />] : []),
    ]);
}
